import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { ShareOutlined } from '@mui/icons-material';
import { ChatHistoryView } from '../ChatClient/ChatHistoryView';
import { LiveShareLink } from './LiveShareLink';
import { useCurrentThreadContext } from '../../contexts/CurrentThreadContext';
import { ShareChatDialog } from './ShareChatDialog';
import { useShareChat } from '../../hooks/useShareChat';

export function ChatMainPanel() {
  const { history, awaitingResponse } = useCurrentThreadContext();
  const shareChat = useShareChat();
  const hasMessages = history.length > 0;

  return (
    <Box sx={{ gridArea: 'main', overflowY: 'auto', pr: { xs: 0, md: 1 }, position: 'relative', minHeight: 0, maxHeight: '100%' }}>
      {hasMessages ? (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 1 }}>
            <LiveShareLink hidden={!hasMessages} />
            <Button
              variant="outlined"
              size="small"
              startIcon={<ShareOutlined />}
              disabled={history.length === 0}
              onClick={shareChat.openShareChatDialog}
              sx={{ textTransform: 'none' }}
            >
              Chatverlauf exportieren
            </Button>
          </Box>
          <ChatHistoryView />
        </Box>
      ) : (
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px dashed #1f242f',
            borderRadius: 2,
            color: 'text.secondary',
            textAlign: 'center',
            p: 2,
          }}
        >
          Noch keine Unterhaltungen – nutze die Suchbox unten.
        </Box>
      )}

      {!hasMessages && <LiveShareLink hidden />}

      {awaitingResponse && (
        <Box
          sx={(theme) => ({
            position: 'absolute',
            top: 12,
            right: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            bgcolor: theme.palette.mode === 'dark'
              ? 'rgba(15,17,22,0.9)'
              : 'rgba(255,255,255,0.92)',
            border: `1px solid ${theme.palette.mode === 'dark' ? '#1f242f' : theme.palette.divider}`,
            borderRadius: 2,
            px: 1.5,
            py: 1,
            boxShadow: theme.palette.mode === 'dark' ? 4 : '0 10px 24px rgba(15,23,42,0.12)',
          })}
        >
          <CircularProgress size={20} />
          <Typography variant="caption" color="text.secondary">
            Antwort wird geladen …
          </Typography>
        </Box>
      )}
      <ShareChatDialog
        open={shareChat.shareChatOpen}
        onClose={() => shareChat.setShareChatOpen(false)}
        addShareChatRecipient={shareChat.addShareChatRecipient}
        shareChatRecipients={shareChat.shareChatRecipients}
        setShareChatRecipients={shareChat.setShareChatRecipients}
        shareChatSubject={shareChat.shareChatSubject}
        setShareChatSubject={shareChat.setShareChatSubject}
        shareChatSending={shareChat.shareChatSending}
        sendChatShare={shareChat.sendChatShare}
        downloadChatExport={shareChat.downloadChatExport}
      />
    </Box>
  );
}
